import React from "react";

interface TopBarProps {
  left?: () => JSX.Element | string;
  right?: () => JSX.Element | string;
  children?: React.ReactChild;
}

export const TopBar = (props: TopBarProps) => {
  return (
    <div className="px-2 tablet:px-10 txt-field-description tablet:txt-body-16 h-8 tablet:h-10 flex items-center justify-between bg-off-black text-white">
      {props.left ? <div className="hidden tablet:block">{props.left()}</div> : null}
      <div className="text-center flex-grow overflow-hidden overflow-ellipsis whitespace-nowrap">
        {props.children || null}
      </div>
      {props.right ? <div className="hidden tablet:block">{props.right()}</div> : null}
    </div>
  );
};
